import { render, staticRenderFns } from "./ScoreGame.vue?vue&type=template&id=14531d6e&"
import script from "./ScoreGame.vue?vue&type=script&lang=js&"
export * from "./ScoreGame.vue?vue&type=script&lang=js&"
import style0 from "./ScoreGame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports